// extracted by mini-css-extract-plugin
export default {"kvmTip":"app-edge-EdgeDevices-EdgeDevicesView-EdgeDevicesDatatable-EdgeDevicesDatatable-module__kvm-tip"};